import { render, staticRenderFns } from "./ConfirmedButton.vue?vue&type=template&id=31492b26&lang=pug&"
import script from "./ConfirmedButton.vue?vue&type=script&lang=ts&"
export * from "./ConfirmedButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports